"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.reduce-right");

require("core-js/modules/es6.array.last-index-of");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _pipe = _interopRequireDefault(require("unmutable/lib/util/pipe"));

var _Errors = require("../errors/Errors");

var _delete = _interopRequireDefault(require("../parcelData/delete"));

var _deleteSelfWithMarker = _interopRequireDefault(require("../parcelData/deleteSelfWithMarker"));

var _insertAfter = _interopRequireDefault(require("../parcelData/insertAfter"));

var _insertBefore = _interopRequireDefault(require("../parcelData/insertBefore"));

var _map2 = _interopRequireDefault(require("../parcelData/map"));

var _pop = _interopRequireDefault(require("../parcelData/pop"));

var _push2 = _interopRequireDefault(require("../parcelData/push"));

var _setMeta2 = _interopRequireDefault(require("../parcelData/setMeta"));

var _setSelf = _interopRequireDefault(require("../parcelData/setSelf"));

var _shift = _interopRequireDefault(require("../parcelData/shift"));

var _swap = _interopRequireDefault(require("../parcelData/swap"));

var _swapNext = _interopRequireDefault(require("../parcelData/swapNext"));

var _swapPrev = _interopRequireDefault(require("../parcelData/swapPrev"));

var _unshift2 = _interopRequireDefault(require("../parcelData/unshift"));

var _update = _interopRequireDefault(require("../parcelData/update"));

var actionMap = {
  "delete": _delete["default"],
  //: (lastKey) => del(lastKey),
  insertAfter: _insertAfter["default"],
  //: (lastKey, value) => insertAfter(lastKey, value),
  insertBefore: _insertBefore["default"],
  //: (lastKey, value) => insertBefore(lastKey, value),
  map: function map(lastKey, updater) {
    return (0, _map2["default"])(updater);
  },
  pop: _pop["default"],
  //: () => pop(),
  push: function push(lastKey, values) {
    return _push2["default"].apply(void 0, (0, _toConsumableArray2["default"])(values));
  },
  setData: function setData(lastKey, parcelData) {
    return function () {
      return parcelData;
    };
  },
  setMeta: function setMeta(lastKey, meta) {
    return (0, _setMeta2["default"])(meta);
  },
  set: function set(lastKey, value) {
    return (0, _setSelf["default"])(value);
  },
  shift: _shift["default"],
  //: () => shift(),
  swap: _swap["default"],
  //: (lastKey, swapKey) => swap(lastKey, swapKey),
  swapNext: _swapNext["default"],
  //: (lastKey) => swapNext(lastKey),
  swapPrev: _swapPrev["default"],
  //: (lastKey) => swapPrev(lastKey),
  unshift: function unshift(lastKey, values) {
    return _unshift2["default"].apply(void 0, (0, _toConsumableArray2["default"])(values));
  }
};
var parentActionMap = {
  "delete": true,
  insertAfter: true,
  insertBefore: true,
  swap: true,
  swapNext: true,
  swapPrev: true
};
var stepMap = {
  get: function get(_ref, next) {
    var key = _ref.key;
    return (0, _update["default"])(key, next);
  },
  md: function md(_ref2, next) {
    var updater = _ref2.updater;
    return (0, _pipe["default"])(updater, next);
  },
  mu: function mu(_ref3, next) {
    var updater = _ref3.updater,
        changeRequest = _ref3.changeRequest;
    return function (prevData) {
      var nextData = next(prevData);
      return updater(nextData, changeRequest && changeRequest._create({
        prevData: prevData,
        nextData: nextData
      }));
    };
  }
};

var doAction = function doAction(_ref4) {
  var keyPath = _ref4.keyPath,
      type = _ref4.type,
      payload = _ref4.payload;
  var fn = actionMap[type];

  if (!fn) {
    throw (0, _Errors.ReducerInvalidActionError)(type);
  }

  return fn(keyPath.slice(-1)[0], payload);
};

var doDeepAction = function doDeepAction(action) {
  var steps = action.steps,
      type = action.type;
  var isParentAction = !!parentActionMap[type];

  if (isParentAction) {
    if (action.keyPath.length === 0) {
      return type === "delete" ? _deleteSelfWithMarker["default"] : function (ii) {
        return ii;
      };
    }

    var lastGetIndex = steps.lastIndexOf(function (step) {
      return step.type === 'get';
    });
    steps = steps.slice(0, lastGetIndex);
  }

  return steps.reduceRight(function (next, step) {
    var fn = stepMap[step.type];

    if (!fn) {
      throw (0, _Errors.ReducerInvalidStepError)(step.type);
    }

    return fn(step, next);
  }, doAction(action));
};

var _default = function _default(changeRequest) {
  return function (parcelData) {
    var someSucceeded = false;
    return changeRequest.actions.reduce(function (parcelData, action) {
      try {
        var newParcelData = doDeepAction(action)(parcelData);
        someSucceeded = true;
        return newParcelData;
      } catch (e) {
        if (e.message === 'CANCEL') {
          return someSucceeded ? parcelData : undefined;
        }

        throw e;
      }
    }, parcelData);
  };
};

exports["default"] = _default;